import React from "react";
import { Fragment } from "core/components/FragmentProvider";
import { Article } from "./entities";
import { Classes, H6 } from "@blueprintjs/core";
import { Input } from "decorator-form";
import { Entity, Field } from "typegraph";
import { ID } from "common/entities/IEntity";
import InputType from "common/form/InputType";
import { IPageableListQuery } from "common/models/IPageableListQuery";
import { EntityTable } from "core/components/EntityTable";
import CountResult from "panels/organizationParticipant/entities/CountResult";
import entityMeta from "../entityMeta";
import { IFileUpload } from "common/form/fields/upload/UploadField";

class File {
	@Field()
	public id: ID;

	@Field()
	public displayName: string;

	@Field()
	public description: string;

	@Field()
	public name: string;

	@Field()
	public url: string;

	@Field()
	public contentType: string;
}

@Entity(entityMeta.ATTACHMENT)
class Attachment {
	@Field()
	public id: ID;

	@Field()
	public fileUrl: string;

	@Input({
		type: InputType.UPLOAD,
		title: "File",
		required: true,
	})
	public tempUpload?: IFileUpload;

	@Field({ entity: File })
	public file: File;

	@Input({ type: InputType.TEXT, title: "Name", required: true })
	public fileDisplayName?: string;

	@Input({ type: InputType.TEXT_HTML, title: "Description" })
	public fileDescription?: string;
}

function mapQueryParams(args: any) {
	const params = {};

	Object.entries(args).forEach(([key, value]) => {
		if (value) {
			params[key] = value;
		}
	});

	return { params };
}

class AttachmentQuery implements IPageableListQuery<Attachment> {
	@Field({
		entity: Attachment,
		aliasFor: "kbAttachment_many",
		params: mapQueryParams,
	})
	public entities: null | Attachment[];

	@Field({
		entity: CountResult,
		aliasFor: "kbAttachment_count",
		params: mapQueryParams,
	})
	public count: CountResult;
}

interface IArticleEditFragmentProps {
	article: Article;
}

export const attacmentList: Fragment<IArticleEditFragmentProps> = {
	name: "Attachment",
	component: (props) => {
		const params = {};

		if (props.article && props.article.id) {
			params["articleId"] = props.article.id;
		} else {
			return null;
		}

		return (
			<EntityTable
				pagingQuery={AttachmentQuery}
				formClass={Attachment}
				params={params}
				canCreate={false}
				canDelete={false}
				canUpdate={false}
				columns={[
					{
						key: "name",
						label: "Name",
						renderCell: ({ data }) => {
							return (
								<div>
									<H6>{data.file.displayName}</H6>
									<div
										className={Classes.TEXT_MUTED}
										dangerouslySetInnerHTML={{
											__html: data.file.description,
										}}
									/>
								</div>
							);
						},
					},
					{
						key: "downnload",
						renderCell: ({ data }) => {
							return (
								<div style={{ textAlign: "right" }}>
									<a
										href={data.fileUrl}
										target="_blank"
										download
									>
										Download
									</a>
								</div>
							);
						},
					},
				]}
			/>
		);
	},
};



// WEBPACK FOOTER //
// ./src/panels/articleDetails/article/attachmentFragments.tsx